import './cover.css'
import './web_component'
import React from 'react'
import { CoverLayoutProps } from './types'

export const Cover: React.FC<CoverLayoutProps> = ({ children, ...props }) => <cover-l {...props}>{children}</cover-l>
